import { LinkedinLogoIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Linkedin = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <LinkedinLogoIcon size={Sizes[size]} color={stroke || fill} {...rest} />;
};

Linkedin.displayName = 'Linkedin';
